<template>
  <div class="chart-container">
    <canvas ref="canvas" class="canvas-graph"></canvas>
  </div>
</template>

<script>
import { Bar } from "vue-chartjs";

Chart.defaults.global.legend.display = false;

import ChartDataLabels from "chartjs-plugin-datalabels";

import ChartSettings from "./chart.settings.js";

import moment from "moment";

export default {
  extends: Bar,
  data () {
    return {
      labels: [],
      delivery_data: [],
      preorder_data: [],
      inside_data: []
    };
  },
  props: {
    inside: Array,
    preorder: Array,
    delivery: Array
  },
  watch: {
    inside () {
      this.rerender();
    }
  },
  methods: {
    buildDataset () {
      // const map_data = {};

      // let time_ptr = moment().startOf('week');
      // const end_ptr = moment().endOf('week');

      // while (time_ptr.isBefore(end_ptr)) {
      //   map_data[time_ptr.format('DD.MM.YYYY')] = {
      //     inside: 0,
      //     preorder: 0,
      //     delivery: 0
      //   };
      //   time_ptr = time_ptr.add(1, 'day');
      // }

      // const callback = (map_data, item, mode) => {
      //    const key = moment(item.created_at || item.date).format('DD.MM.YYYY');

      //     if (!map_data[key]) return;

      //     if (!map_data[key][mode]) map_data[key][mode] = 0;

      //     map_data[key][mode] += item.total;
      // };

      // this.inside.forEach(item => callback(map_data, item, 'inside'));
      // this.delivery.forEach(item => callback(map_data, item, 'delivery'));
      // this.preorder.forEach(item => callback(map_data, item, 'preorder'));

      // this.inside_data = Object.values(map_data).map(record => record.inside);
      // this.preorder_data = Object.values(map_data).map(record => record.preorder);
      // this.delivery_data = Object.values(map_data).map(record => record.delivery);

      // this.labels = Object.keys(map_data).map(date => {
      //   return moment(date, 'DD.MM.YYYY').format('ddd');
      // });

      if (this.inside.length <= 14) {
        this.labels = this.inside.map(d =>
          moment(d.timestamp, "DD.MM.YYYY").format("ddd")
        );
      } else {
        this.labels = this.inside.map(d => d.timestamp);
      }
      this.inside_data = this.inside.map(d => d.income);
      this.preorder_data = this.preorder.map(d => d.income);
      this.delivery_data = this.delivery.map(d => d.income);
    },
    rerender () {
      this.buildDataset();
      this.renderChart(
        {
          labels: this.labels,
          datasets: [
            {
              data: this.delivery_data,
              backgroundColor: "#CBD9E6",
              hoverBackgroundColor: "#CBD9E6"
            },
            {
              data: this.preorder_data,
              backgroundColor: "#FFD2A8",
              hoverBackgroundColor: "#FFD2A8"
            },
            {
              data: this.inside_data,
              backgroundColor: "#129B81",
              hoverBackgroundColor: "#129B81"
            }
          ]
        },
        {
          scales: ChartSettings.scales
        }
      );
    }
  },
  mounted () {
    this.addPlugin(ChartDataLabels);
    this.rerender();
  }
};
</script>

<style scoped>
.canvas-graph {
  background: #1d1d1b;
  padding-top: 5vh;
  width: 75vh !important;
  height: 50vh !important;
  border-radius: 0 0 1vh 1vh;
}

.chart-container {
  width: min-content;

  display: block;
}
</style>